import { render, staticRenderFns } from "./DynamicItemList.vue?vue&type=template&id=422fd9b2"
import script from "./DynamicItemList.vue?vue&type=script&lang=js"
export * from "./DynamicItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports